import { OrderRowDisplay } from "../orderAPI";

export enum TalentPool {
  MANUAL = "MANUAL",
  WORK_LOCATION = "WORK_LOCATION",
}

// GroupedTable expects orderHandler to be string type
export interface OrderRowDisplayFormatted
  extends Omit<OrderRowDisplay, "orderHandlers" | "assignedTalents"> {
  orderHandlers: JSX.Element | string;
  assignedTalents: JSX.Element;
}

export interface OrderGroup {
  items: OrderRowDisplayFormatted[];
  name: string;
  year?: string;
}
